import mutations from '@src/store/mutations'
import { ruleTypes } from '@src/scripts/enums'

export const methods = {
  updateBrowserData,
  updateToken,
  updateCameraState,
  acceptTerms,
  activateOmnichannel
}

export default new Proxy(methods, {
  get(target, key) {
    if (!target[key]) {
      throw `Action key ${key} not exist.`
    }
    return key
  }
})

function activateOmnichannel({ commit }) {
  commit(mutations.setPages)
}

function updateBrowserData({ commit }, value) {
  commit(mutations.changeBrowserData, value)
}

function updateToken({ commit, state }, value) {
  value = value || null
  if (!state.accessData || value !== state.accessData.token) {
    const accessData = {
      token: value
    }
    commit(mutations.changeToken, accessData)
  }

  if (!value && !state.sessionExists) {
    commit(mutations.updateSession)
  }
}

function updateCameraState({ commit, state: { camera } }, value) {
  if (!value || camera.state === value) return
  commit(mutations.changeCameraState, value)
}

function acceptTerms({ commit, state: { session } }) {
  if (!session || !session.rules || !session.rules.length) return

  const rules = session.rules.filter(
    (rule) => rule.name !== ruleTypes.termsAndConditions
  )
  commit(mutations.updateRules, rules)
}
